import Enumeration from './enum';

const WeekDaysEnum = new Enumeration({
  MONDAY: 'monday',
  TUEDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
});

/**
 * @param {Object} i18n
 * @param {Object} options - { isAbbreviation: true }
 *
 * @returns Array
 */
export function getWeekDaysTranslated(i18n, { isAbbreviation } = { isAbbreviation: true }) {
  const version = isAbbreviation ? 'short' : 'full';

  return WeekDaysEnum.values()
    .map((day) => ({ key: day, value: i18n.t(`common.week_days.${version}.${day}`) }));
}

export default WeekDaysEnum;
